<!-- <app-data-table [columns]="cols" [data]="systems" [title]="title"></app-data-table> -->


<ng-container>
  <app-data-table [columns]="cols" [data]="system" [isCardView]="false" (onPresentView)="getSystem()"
    [isDeletable]="'/master/class' | hasPermission: 'Delete'"  [showAddButton]="'/master/class' | hasPermission: 'Add'" [showActions]="canEditSetup" [isEditable]="'/master/class' | hasPermission: 'Edit'"  [title]="title" (onAdd)="addSystem()" (editEventRow)="updateSystem($event)" [isView]="'/master/class' | hasPermission: 'View'" (viewEventRow)="viewSystem($event)"
    (deleteEventRow)="showDeletePopup($event)" (onLazyLoadData)="getSystem($event)" [totalRecords]="totalRecords">
  </app-data-table>
</ng-container>

<p-dialog header="Create Milestone" [(visible)]="showDialog" [modal]="true" [style]="{width: '500px' , height:'auto'}"
  [closable]="true" [dismissableMask]="true" [maximizable]="true">

  <form [formGroup]="systemForm" (ngSubmit)="onSubmitadd()" class="form-wrapper">
    <div>
      <div class="mt-4 mb-3">
        <label class="form-label"><b>Name</b></label>
        <input type="text" class="form-control" formControlName="name" maxlength="100">
         <div *ngIf="systemForm.get('name')?.touched">
          <small class="text-danger" *ngIf="systemForm.get('name')?.hasError('required')">
            Name is required.
          </small>
          <small class="text-danger" *ngIf="systemForm.get('name')?.hasError('pattern')">
            Name must be alphanumeric and can include spaces and '&' only.
          </small>
        </div>
      </div>


      <div class="mt-4 mb-3">
        <label for="section"><b>Description</b></label>
        <textarea class="form-control" formControlName="description" rows="4" ></textarea>
         <div *ngIf="systemForm.get('description')?.touched">
          <small class="text-danger" *ngIf="systemForm.get('description')?.hasError('required')">
            Description is required.
          </small>
          <small class="text-danger" *ngIf="systemForm.get('description')?.hasError('pattern')">
            Description must be alphanumeric and can include spaces and '&' only.
          </small>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-end mt-3 btn-wrapper">
      <!-- <button type="button" class="btn btn-secondary" (click)="onCancel()">Cancel</button> -->
      <button type="submit" class="btn btn-primary me-2" [disabled]="systemForm.invalid">Submit</button>
    </div>

  </form>
</p-dialog>


<p-dialog [header]="viewMode ? 'View Milestone' : 'Update Milestone'" [(visible)]="isUpdatedialog" [modal]="true" [style]="{width: '500px' , height:'auto'}"
  [closable]="true" [dismissableMask]="true" [maximizable]="true"
  [contentStyle]="{'display': 'flex', 'flexDirection': 'column', 'height': '100%' , 'justify-content' : 'space-between'}">

  <form [formGroup]="systemForm" (ngSubmit)="onSubmitEq()" class="form-wrapper">
    <div>
      <div class="mt-4 mb-3">
        <label class="form-label"><b>Name</b></label>
        <input type="text" class="form-control" formControlName="name" maxlength="100">
        <div *ngIf="systemForm.get('name')?.touched">
          <small class="text-danger" *ngIf="systemForm.get('name')?.hasError('required')">
            Name is required.
          </small>
          <small class="text-danger" *ngIf="systemForm.get('name')?.hasError('pattern')">
            Name must be alphanumeric and can include spaces and '&' only.
          </small>
        </div>
      </div>

      <div class="mt-4 mt-3">
        <label for="section"><b>Description</b></label>
        <textarea class="form-control" formControlName="description" rows="4" maxlength="500"></textarea>
         <div *ngIf="systemForm.get('description')?.touched">
          <small class="text-danger" *ngIf="systemForm.get('description')?.hasError('required')">
            Description is required.
          </small>
          <small class="text-danger" *ngIf="systemForm.get('description')?.hasError('pattern')">
            Description must be alphanumeric and can include spaces and '&' only.
          </small>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-end mt-3 btn-wrapper">
      <!-- <button type="button" class="btn btn-secondary" (click)="onCancel()">Cancel</button> -->
      <button type="submit" class="btn btn-primary " *ngIf="!viewMode" [disabled]="systemForm.invalid || systemForm.pristine">
        Submit
      </button>

    </div>
  </form>
</p-dialog>

<p-dialog header="Delete Milestone" [modal]="true" [(visible)]="showDeleteDialog" [style]="{ width: '30rem' }" [maximizable]="true">
  <div class="delete-dialog mt-3">
     <i class="pi pi-trash text-danger custom-delete-icon"></i>
    <span>Are you sure , you want to delete class ?</span>
    <p-button label="Delete" icon="pi pi-trash" severity="danger" [outlined]="true" (click)="deleteSystem()" class="mt-2">
    </p-button>
  </div>
</p-dialog>